export default "__VITE_ASSET__OueUUt3a__"